export enum AlertTypes {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}

export type Alert = {
  message: string;
  severity: AlertTypes;
};
